export function updateEndDateInPubmedQuery(queryString: string): string {
  const regex = /(\d{4}\/\d{2}\/\d{2})( \d{2}:\d{2})?"?\[Date - Publication\]/;
  const match = regex.exec(queryString);

  if (match) {
    const endDate = match[1];
    const [year, month, day] = endDate.split("/").map(Number);
    const endDateUtcMs = Date.UTC(year, month - 1, day);
    const cappedUtcMs = Math.min(Date.now(), endDateUtcMs);
    const capped = new Date(cappedUtcMs);
    const newDateString = [
      capped.getUTCFullYear(),
      String(capped.getUTCMonth() + 1).padStart(2, "0"),
      String(capped.getUTCDate()).padStart(2, "0"),
    ].join("/");
    return queryString.replace(endDate, newDateString);
  }

  return queryString;
}
